﻿<script setup lang="ts">
    import { computed } from 'vue';
    import MarkdownIt from 'markdown-it';

    const props = defineProps({
        source: {
            type: String,
            required: true
        },
        htmlEnabled: {
            type: Boolean,
            default: true
        }
    });

    const markdown = new MarkdownIt().set({
        html: props.htmlEnabled,
        breaks: true,
        typographer: true
    });

    const content = computed(() => {
        return markdown.render(props.source ?? '');
    });

</script>

<template>
    <!--eslint-disable-next-line vue/no-v-html-->
    <div v-html="content" /><!--content here is generated by markdown-it-->
</template>
